import styled from "styled-components";
import Icon from "../../icon";
export const Container = styled.div`
  box-sizing: border-box;
  height: 100%;
  padding: 16px 20px;
  width: 100%;
  display: flex;
  justify-content: space-between;
`;

export const SocialBox = styled.div`
  display: flex;
  // min-width: 466px;
  justify-content: flex-end;
`;

export const WhatsNumber = styled.div`
  display: flex;
  align-items: center;
`;

export const SocialList = styled.ul`
  align-items: center;
  display: flex;
  justify-content: space-between;
  margin: 0;
  max-width: 560px;
  padding: 0;
  width: 100%;
  list-style: none;

  @media (max-width: 1919px) {
    max-width: 375px;
  }

  @media (max-width: 1365px) {
    max-width: 290px;
  }

  @media (max-width: 1023px) {
    max-width: 100%;
  }
`;

export const SocialItem = styled.li`
  &:last-of-type {
    margin-right: 98px;
  }
  margin-right: 35px;
`;

export const SocialLink = styled.a`
  display: flex;
`;

export const SocialIcon = styled(Icon)`
  fill: ${(props) => props.color};

  @media (max-width: 1365px) {
    height: 25px;
    width: 40px;
  }

  @media (max-width: 1023px) {
    height: 32px;
    width: 45px;
  }

  @media (max-width: 767px) {
    height: 16px;
    width: 22px;
  }
`;

export const SocialImg = styled.img`
  height: 24px;
  width: 34px;

  @media (max-width: 1365px) {
    height: 25px;
    width: 40px;
  }

  @media (max-width: 1023px) {
    height: 32px;
    width: 45px;
  }

  @media (max-width: 767px) {
    height: 16px;
    width: 22px;
  }
`;

export const HelperLinks = styled.ul`
  align-items: center;
  display: flex;
  font-family: "Nunito", sans-serif;
  justify-content: space-between;
  margin: 0;
  max-width: 658px;
  width: 100%;
  list-style: none;
  padding-right: 20px;

  @media (max-width: 1365px) {
    padding-left: 0;
  }
`;

export const LinkItem = styled.li`
  @media (max-width: 1023px) {
    margin: 0 0 5px;
  }
`;

export const Link = styled.a`
  color: #ffffff;
  font-size: 1rem;
  font-weight: 400;

  &:hover,
  &:visited {
    color: #ffffff;
  }

  @media (max-width: 1365px) {
    font-size: 1rem;
  }

  @media (max-width: 1023px) {
    font-size: 1.25rem;
  }

  @media (max-width: 767px) {
    font-size: 1rem;
  }
`;

export const AppsBox = styled.div`
  display: flex;
  max-width: 384px;
  width: 100%;
  margin-right: 36px;

  @media (max-width: 1199px) {
    margin: 0 18px;
  }
`;

export const AppsLink = styled.a`
  display: block;

  &:not(:last-of-type) {
    margin: 0 22px 0 0;
  }

  @media (max-width: 1023px) {
    &:not(:last-of-type) {
      margin: 0 0 3px 0;
    }
  }
`;

export const AppsImage = styled.img`
  max-width: 116px;
`;
